import { render, staticRenderFns } from "./TemplateTwoAndFiveList.vue?vue&type=template&id=141dcb33&scoped=true"
import script from "./TemplateTwoAndFiveList.vue?vue&type=script&lang=js"
export * from "./TemplateTwoAndFiveList.vue?vue&type=script&lang=js"
import style0 from "./TemplateTwoAndFiveList.vue?vue&type=style&index=0&id=141dcb33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141dcb33",
  null
  
)

export default component.exports